import type { IGroupNode } from '~/client/src/desktop/components/Resource/buildGroupedRows'
import type { IResourceRecord } from '~/client/src/desktop/components/Resource/types'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { getResourceGroupPaths } from '~/client/src/shared/resources/grouping/getResourceGroupPaths'
import type { IHierarchyAccessors } from '~/client/src/shared/utils/hierarchyAccessors'
import { UNASSIGNED_FILTER_VALUE } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

import {
  resolveControlsGroupEntries,
  type IResolveGroupDeps,
} from './resolveControlsGroupEntries'
import {
  PERMITTED_COMPANIES_KEY,
  SHOW_IN_MAP_KEY,
  WORKFLOW_RESOURCE_KEY,
} from './resourceControlsColumns'

const CONTROL_GROUP_KEYS = new Set([
  PERMITTED_COMPANIES_KEY,
  WORKFLOW_RESOURCE_KEY,
  SHOW_IN_MAP_KEY,
])

export const getControlsGroupPaths = (
  record: IResourceRecord,
  grouping: string,
  deps: IResolveGroupDeps,
  hierarchy: IHierarchyAccessors | undefined,
): IGroupNode[][] => {
  if (CONTROL_GROUP_KEYS.has(grouping)) {
    const entries = resolveControlsGroupEntries(record, grouping, deps)
    if (!entries.length) {
      return [
        [
          {
            value: UNASSIGNED_FILTER_VALUE,
            label: Localization.translator.unassigned,
          },
        ],
      ]
    }
    return entries.map(entry => [{ value: entry.id, label: entry.label }])
  }

  return getResourceGroupPaths(
    record,
    grouping,
    hierarchy,
    deps.fieldProjector,
    Localization.translator.unassigned,
  )
}
